import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const actionPanel = (isLargeDevice: boolean, isMobile: boolean) =>
  css({
    display: 'flex',
    alignItems: 'center',
    ...(isLargeDevice && { justifyContent: 'flex-end' }),
    ...(isMobile && { justifyContent: 'space-between', flex: 1 }),
  });

export const unifyLocationNames = css({
  marginBottom: theme.spacing(2),
});
